import { AgxColumn } from '@urbanx/agx.ui-components2'
import { FinanceMenu, MenuTitles } from 'constants/menu'
import { ContentLayout } from 'layout'

const VpaPage = () => {
  return (
    <ContentLayout
      hasSecondaryMenu={false}
      secondaryActiveMenu={MenuTitles.FINANCE_VPA}
      secondaryMenuOverride={FinanceMenu}
      isCampaigns={true}
    >
      <AgxColumn fill />
    </ContentLayout>
  )
}

export default VpaPage
